export const CURRENT_VERSION = process.env.REACT_APP_VERSION ?? "0.0.0";
